<template>
  <app-shell>
    <vnt-header>Edit item</vnt-header>
    <item-form :year="year" :month="month" :itemId="itemId" />
  </app-shell>
</template>

<script>
import AppShell from '@/components/AppShell.vue'
import ItemForm from '@/components/items/ItemForm.vue'

export default {
  name: 'EditItemView',

  props: ['year', 'month', 'itemId'],

  components: {
    AppShell,
    ItemForm
  }
}
</script>
